import { useSetAtom } from 'jotai'
import React from 'react'
import * as R from 'remeda'
import { z } from 'zod'

import { exists, setValueIfExist } from '~/utils'

import {
  commentAtom,
  dataDisplayTypeAtom,
  hiddenBrandIdsAtom,
  hiddenLabelBrandIdsAtom,
  hiddenSurveyIdsAtom,
  isChartMaxUnifiedAtom,
  savedCommentAtom,
  tableChartTypeAtom,
} from '../../atoms'

import { schema1 } from './schemas/schema1'
import { schema2 } from './schemas/schema2'

const schema = z.union([schema1, schema2])

export const useRestoreParams = () => {
  const setComment = useSetAtom(commentAtom)
  const setSavedComment = useSetAtom(savedCommentAtom)

  const setTableChartType = useSetAtom(tableChartTypeAtom)
  const setDataDisplayType = useSetAtom(dataDisplayTypeAtom)
  const setIsChartMaxUnified = useSetAtom(isChartMaxUnifiedAtom)

  const setHiddenBrandIds = useSetAtom(hiddenBrandIdsAtom)
  const setHiddenLabelBrandIds = useSetAtom(hiddenLabelBrandIdsAtom)
  const setHiddenSurveyIds = useSetAtom(hiddenSurveyIdsAtom)

  return React.useCallback(
    (state: unknown) => {
      const parsed = schema.safeParse(state)
      if (!parsed.success) {
        return null
      }
      const params = parsed.data

      if (exists(params.comment) && exists(params.hash)) {
        const value = params.comment
        const hash = params.hash
        setComment((prev) => ({ ...prev, [hash]: value }))
        setSavedComment((prev) => ({ ...prev, [hash]: value }))
      }
      setValueIfExist(params.tableChartType, setTableChartType)
      setValueIfExist(params.dataDisplayType, setDataDisplayType)
      setValueIfExist(params.isChartMaxUnified, setIsChartMaxUnified)
      setValueIfExist(params.hiddenBrandIds, setHiddenBrandIds)
      setValueIfExist(params.hiddenLabelBrandIds, setHiddenLabelBrandIds)
      setValueIfExist(params.hiddenSurveyIds, setHiddenSurveyIds)

      return R.pick(params, ['hash'])
    },
    [
      setComment,
      setDataDisplayType,
      setHiddenBrandIds,
      setHiddenLabelBrandIds,
      setHiddenSurveyIds,
      setIsChartMaxUnified,
      setSavedComment,
      setTableChartType,
    ],
  )
}
